import React from 'react';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';


export const SumAvgRender = (
  value: string,
  sumInfo: string | React.ReactNode,
) => {
  const val = value?.toLocaleLowerCase();
  if (val === 'sum') {
    if (sumInfo) {
      return (
        <>
          Sum
          <TipContext
            AWidth={600}
            className="dbi-table-sumicon"
            tipText={sumInfo}
          />{' '}
        </>
      );
    }
    return 'Sum';
  }
  if (val === 'max') {
    return 'Max';
  }
  if (val === 'avg') {
    return (
      <span>
        Avg <span style={{ color: '#9B9FB0' }}>(≠Null)</span>
      </span>
    );
  }
};
